'use client'
import React from 'react'
import { SWRConfig } from 'swr'

type Props = {
  children?: React.ReactNode
  fallback?: { [key: string]: any }
  config?: object
}

export default function SWRProvider({
  children,
  fallback,
  config = {},
}: Props) {
  return <SWRConfig value={{ ...config, fallback }}>{children}</SWRConfig>
}
